import { useCallback } from 'react';
import { useHttpClient } from '../../client/HttpClientContext';
import { HubsSettingsCache } from '../../hubsSettings/HubsSettingsCache';
import { useAsyncFunction } from '../../utils/hooks/useAsyncFunction';
export const useSavingMode = (options = {}) => {
  const httpClient = useHttpClient();
  const getSavingMode = useCallback(async () => {
    const setting = await HubsSettingsCache.get({
      settingName: 'CRM:Properties:AutosaveMode',
      defaultValue: 'auto'
    }, httpClient);
    return setting;
  }, [httpClient]);
  return useAsyncFunction(getSavingMode, options);
};